import Sticky from './sticky.js'

const folder = '/events/2021'
const promo = '/promo/lineage'
const url = location.href

const checkActive = (name) => {
  if (name.constructor === Array) {
    name.forEach((item) => {
      if (url.indexOf(item) > -1) name = item
    })
  }
  return url.indexOf(name) > -1 ? 'p-nav__list--on' : ''
}

const template = `<nav id="sticky" class="p-nav">
        <ul class="p-nav__menu"> 
            <li class="p-nav__list p-nav__list--01 ${checkActive(
              `${folder}/210825_signaturecoupon`
            )}"> 
                <a class="p-nav__link" href="${folder}/210825_signaturecoupon">
                    고속 성장 x 아이템 복구
                    시그니처 쿠폰                
                </a>
            </li>
            <li class="p-nav__list p-nav__list--02 ${checkActive([
              `${folder}/210825_mirrorwar/mirror`,
              `${folder}/210825_mirrorwar/versus`,
            ])}">
                <a href="${folder}/210825_mirrorwar/mirror" class="p-nav__link">
                    이계의 세력 등장! 
                    거울전쟁
                </a>
            </li>
            <li class="p-nav__list p-nav__list--03 ${checkActive(
              `${folder}/210811_streaming`
            )}">
                <a href="${folder}/210811_streaming" class="p-nav__link">
                    편리하게 즐기는 리니지!
                    리니지 스트리밍
                </a>
            </li>
            <li class="p-nav__list p-nav__list--04 ${checkActive([
              `${promo}/210825_dark`,
              `${promo}/210825_blessing`,
              `${promo}/210825_supplies`,
            ])}">
                <a href="${promo}/210825_dark" class="p-nav__link">
                    폭풍 성장의 기회!
                    다크 훈련소
                </a>
            </li>
            <li class="p-nav__list p-nav__list--05 ${checkActive(
              `${promo}/210825_growthpackage`
            )}">
                <a href="${promo}/210825_growthpackage" class="p-nav__link">
                    내 맘대로 골라 담는 리니지 X 버프툰 패키지
                </a>
            </li>
            <li class="p-nav__list p-nav__list--06 ${checkActive(
              `${promo}/210825_relic`
            )}">
                <a href="${promo}/210929_growth" class="p-nav__link">
                    빠른 성장을 위한 필수 패키지 영웅의 성장 물약
                </a>
            </li>
        </ul>
        <button type="button" class="p-nav__btn">닫기</button>
    </nav>`

$('body').append(template)

new Sticky({
  el: '#sticky',
  offsetTop: 56,
  openClose: [
    'p-nav--open', // p-nav--close
    'p-nav__btn--open', // p-nav__btn--close
  ],
})



// WEBPACK FOOTER //
// ./src/js/editor-navi.js